import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage"; // ใช้ localStorage
import overdueReducer from "./slices/overdueSlice";
import overdueReducerPawn from "./slices/overuePawn";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  overdue: overdueReducer,
  overduePawn: overdueReducerPawn,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
});

const persistor = persistStore(store);

export { store, persistor };
